import browser from "webextension-polyfill";
import { detectionEvent } from "../shared/index.js";
function start() {
    document.addEventListener(detectionEvent, () => {
        void browser.runtime.sendMessage({
            type: detectionEvent,
        });
    });
}
start();
